import { cn } from 'utils/bem';

export const dialog = cn('dialog');
